const messages = {
    en: {
        payment: {
            paymentMethods: "Payment methods",
            method: {
                formTitle: 'Payment methods setting',
                identifiers: {
                    CASH: "Cash",
                    DEBIT: "Debit",
                    BANK_TRANSFER: "Bank Transfer",
                    MP_TRANSFER: "Mercado Pago Transfer",
                },
                labels: {
                    title: 'Title',
                    info: 0,
                    enable: 'Enable'
                },

            }
        }
    },
    es: {
        payment: {
            paymentMethods: "Métodos de pago",
            method: {
                formTitle: 'Configuración de métodos de pago',
                identifiers: {
                    CASH: "Efectivo",
                    DEBIT: "Débito",
                    BANK_TRANSFER: "Transferencia bancaria",
                    MP_TRANSFER: "Transferencia Mercado Pago"
                },
                labels: {
                    title: 'Titulo',
                    info: 'info',
                    enable: 'Habilitado'
                },

            }
        }
    },
    pt: {
        payment: {
            paymentMethods: "Payment methods",
            method: {
                formTitle: 'Payment methods setting',
                identifiers: {
                    CASH: "Efectivo",
                    DEBIT: "Débito",
                    BANK_TRANSFER: "Transferencia bancaria",
                    MP_TRANSFER: "Transferencia Mercado Pago"
                },
                labels: {
                    title: 'Titulo',
                    info: 'info',
                    enable: 'enable'
                },

            }
        }
    }
}

export default messages
